// extracted by mini-css-extract-plugin
export default {"contactDetails":"Contact_contactDetails__Iv2bk","colCont":"Contact_colCont__g79QQ","contactPage":"Contact_contactPage__HtcWu","mobile":"Contact_mobile__o1hwj"};